import { FC, useCallback, useRef, useState } from 'react';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from '../../../components/Text';
import { COLORS, FONTS } from '../../../constants';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { IBookingState } from '../types';
import { IBankData } from '../../../types/camp.types';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { IS_WEB, SCREEN_WITDH } from '../../../constants/platform';
import { STYLE_VARS } from '../../../constants/style-vars';
import {
  launchImageLibrary,
  launchCamera,
  Asset,
} from 'react-native-image-picker';
import CampApi from '../../../services/api/camp.api';
import { Alert } from '../../../services/alert';
import { Loading } from '../../../components';
import { DocumentPickerResponse, pick } from 'react-native-document-picker';

type BankingBookingProps = {
  state: IBookingState;
  bankTransferData: IBankData;
  moveScreenToTop: () => void;
};

const BankingBooking: FC<BankingBookingProps> = ({
  state,
  bankTransferData,
  moveScreenToTop,
}) => {
  const isDesktop = useIsDesktop();
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [file, setFile] = useState<
    File | { name: string; uri: string; type: string }
  >();
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const uploadReceipt = useCallback(
    async (image: any) => {
      setIsUploading(true);
      var formData = new FormData();
      formData.append('receipt', image);

      if (state.booking_id) {
        CampApi.postUploadReceipt(state.booking_id, formData)
          .then((res) => {
            setIsSuccess(true);
            moveScreenToTop();
          })
          .catch((error) => {
            Alert.alert('Error', error.meta.message);
          })
          .finally(() => {
            setIsUploading(false);
          });
      }
    },
    [state.booking_id, moveScreenToTop]
  );

  return (
    <View
      style={{
        paddingHorizontal: 40,
        paddingTop: 20,
        backgroundColor: '#fdfdfd',
      }}
    >
      <View>
        <View
          style={{
            paddingBottom: 10,
            marginBottom: 15,
          }}
        >
          <Text
            style={{
              fontFamily: FONTS.Arial,
              fontWeight: '700',
              fontSize: 20,
              color: COLORS.BLACK,
              textTransform: 'uppercase',
              textAlign: 'center',
              marginBottom: 10,
              letterSpacing: 2,
            }}
          >
            Thanks for your camp booking
          </Text>
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '500',
              fontSize: 20,
              color: COLORS.BLACK,
              textAlign: 'center',
              marginBottom: 10,
            }}
          >
            Your booking is pending.
          </Text>
        </View>
        <View
          style={[
            {
              flexDirection: 'column',
              borderRadius: 18,
            },
            isDesktop()
              ? {
                  elevation: 5,
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  paddingTop: 25,
                  paddingHorizontal: 25,
                  marginBottom: 150,
                }
              : {
                  backgroundColor: COLORS.WHITE,
                  paddingTop: 20,
                },
          ]}
        >
          {!isSuccess ? (
            <>
              <View style={{ marginBottom: 30 }}>
                <View style={{ marginBottom: 20 }}>
                  <Text style={[styles.textHeader]}>
                    Please make payment to the following bank:
                  </Text>
                  <Text
                    style={styles.text}
                  >{`Bank: ${bankTransferData.bank_name}`}</Text>
                  <Text
                    style={styles.text}
                  >{`Account Name: ${bankTransferData.account_name}`}</Text>
                  <Text
                    style={styles.text}
                  >{`Account Number: ${bankTransferData.account_number}`}</Text>
                </View>
                {/* <View style={{ marginBottom: 20 }}>
              <Text style={styles.textHeader}>Or Pay Via FPS via:</Text>
              <Text
                style={styles.text}
              >{`Email: ${bankTransferData.fps_mail}`}</Text>
            </View>
            <View
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 20,
              }}
            >
              <Text style={styles.textHeader}>QR Code:</Text>
              <View
                style={{
                  alignSelf: 'center',
                  width: 200,
                  height: 200,
                  backgroundColor: COLORS.WHITE,
                  borderWidth: 2,
                  borderColor: COLORS.BLACK,
                }}
              ></View>
            </View> */}
              </View>
              <View style={{ marginBottom: 20 }}>
                <Text style={styles.textHeader}>
                  Upload Receipt Once Transaction Complete:
                </Text>
                <View
                  style={{ flexDirection: 'row', gap: 20, marginBottom: 20 }}
                >
                  <Button
                    text="UPLOAD FILE"
                    style={[
                      STYLE_VARS.fullWRedButton,
                      IS_WEB && { paddingHorizontal: 20 },
                    ]}
                    onPress={async () => {
                      if (IS_WEB) {
                        if (inputFileRef.current) {
                          inputFileRef.current.click();
                        }
                      } else {
                        {
                          /* Disable on website */
                        }
                        // try {
                        //   const [result] = await pick({
                        //     mode: 'open',
                        //   });

                        //   if (result) {
                        //     setFile({
                        //       name: result.name ?? '',
                        //       uri: result.uri,
                        //       type: result.type ?? '',
                        //     });
                        //   }
                        // } catch (err) {
                        //   console.log(err);
                        // }
                      }
                    }}
                  />
                  {!IS_WEB && (
                    <Button
                      text="TAKE PHOTO"
                      style={STYLE_VARS.fullWRedButton}
                      onPress={async () => {
                        {
                          /* Disable on website */
                        }
                        // const result = await launchCamera({
                        //   mediaType: 'photo',
                        // });
                        // if (result.assets && result.assets[0]) {
                        //   setFile({
                        //     name: result.assets[0].fileName ?? '',
                        //     type: result.assets[0].type ?? '',
                        //     uri: result.assets[0].uri ?? '',
                        //   });
                        // }
                      }}
                    />
                  )}
                </View>
                {IS_WEB && (
                  <input
                    type={'file'}
                    id={'photo_upload'}
                    name={'file'}
                    ref={inputFileRef}
                    style={{
                      width: 0.1,
                      height: 0.1,
                      opacity: 0,
                      overflow: 'hidden',
                      position: 'absolute',
                      zIndex: -1,
                    }}
                    onChange={(e) => {
                      if (e.currentTarget.files && e.currentTarget.files[0]) {
                        setFile(e.currentTarget.files[0]);
                      }
                    }}
                  />
                )}
                {/* {preview && (
              <View style={{ marginTop: 10, marginBottom: 20 }}>
                <Image
                  source={{ uri: preview }}
                  style={{
                    width: Math.min(
                      isDesktop() ? 1250 * 0.4 : SCREEN_WITDH - 80,
                      imageWidth
                    ),
                    height:
                      Math.min(
                        isDesktop() ? 1250 * 0.4 : SCREEN_WITDH - 80,
                        imageWidth
                      ) *
                      (imageHeight / imageWidth),
                    resizeMode: 'contain',
                  }}
                />
              </View>
            )} */}
                {file && (
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      marginBottom: 20,
                      gap: 10,
                      alignContent: 'center',
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: FONTS.AvenirMedium,
                        fontWeight: '500',
                        fontSize: 15,
                        color: COLORS.DARKER_GREY,
                        flex: 1,
                      }}
                    >
                      {file.name}
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        setFile(undefined);
                      }}
                    >
                      <Image
                        style={{ width: 20, height: 20 }}
                        source={require('../../../assets/close-circle-icon.png')}
                      />
                    </TouchableOpacity>
                  </View>
                )}
                <Text style={styles.text}>
                  We will email confirmation of your booking once we've matched
                  the transaction with our records.
                </Text>
              </View>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginBottom: 30,
                }}
              >
                <Button
                  style={[
                    styles.buttonStyle,
                    !isDesktop() && { width: '100%', paddingVertical: 30 },
                    !file && { backgroundColor: COLORS.DISABLED_RED },
                  ]}
                  className=""
                  arrowRight={false}
                  textStyle={[
                    styles.textButtonStyle,
                    !isDesktop() && { fontSize: 19 },
                  ]}
                  text="SUBMIT"
                  onPress={() => {
                    if (file) {
                      uploadReceipt(file);
                    }
                  }}
                  disabled={!file}
                />
              </View>
            </>
          ) : (
            <>
              <View style={{ marginBottom: 30 }}>
                <Text style={[styles.text, { textAlign: 'center' }]}>
                  Thanks for making the bank transaction and uploading your
                  receipt. We will confirm your booking as soon as possible via
                  email.
                </Text>
              </View>
              <View>
                <View
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    marginBottom: 30,
                  }}
                >
                  <Button
                    style={[
                      styles.buttonStyle,
                      !isDesktop() && { width: '100%', paddingVertical: 30 },
                    ]}
                    className=""
                    arrowRight={false}
                    textStyle={[
                      styles.textButtonStyle,
                      !isDesktop() && { fontSize: 19 },
                    ]}
                    text="CONTINUE TO HOME"
                    onPress={() => {
                      NavigationService.push('Root', {
                        screen: 'HomeTab',
                      });
                    }}
                  />
                </View>
              </View>
            </>
          )}
        </View>
      </View>
      {isUploading && <Loading isFullScreen />}
    </View>
  );
};

export default BankingBooking;

const styles = StyleSheet.create({
  textHeader: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '800',
    fontSize: 16,
    color: COLORS.BLACK,
    marginBottom: 10,
  },
  text: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 15,
    color: COLORS.BLACK,
    marginBottom: 5,
  },
  buttonStyle: {
    backgroundColor: COLORS.RED_PRIMARY,
    paddingVertical: 20,
    borderRadius: 13,
    width: 300,
    marginBottom: 20,
    overflow: 'hidden',
  },
  textButtonStyle: {
    color: COLORS.WHITE,
    fontSize: 17,
    fontFamily: FONTS.AvenirMedium,
    textTransform: 'uppercase',
    fontWeight: '500',
    letterSpacing: 1,
  },
});
